import { styled } from '@mui/material/styles'
import logoheader from '../../../assets/image/logopie.png';
import { useNavSectionStore } from '../../../hooks/useNavSectionStore'
import { useDrawerStore } from '../../../hooks/useDrawerStore'
import Searcher from './Searcher'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu'
import { AppBar, Badge, Box, Button, Grid, IconButton, Toolbar } from '@mui/material';
import { FC, useState } from 'react';
import { useSearcherStore } from '../../../hooks/useSearcherStore';
import { useShoppingCartStore } from '../../../hooks/useShoppingCartStore';
import AccountPopover from '../../../components/common/Header/AccountPopover';
import { Navigate, useNavigate } from 'react-router-dom';
import { RoutesMap } from '../../../types';
import { useTicketStore } from '../../../hooks/useTicketStore';
import { SearcherV3Popover } from './SearcherV3Popover';

const HeaderV3: FC<any> = (props): JSX.Element | any => {
    const { getSearchProducts, setdatasearch, handleSelectProduct, showMoreProduct } = props;

    const nagivate = useNavigate()
    const [search, setSearch] = useState<string>('');
    const [searchTimeout, setSearchTimeout] = useState<any>(null);
    const [showSearcher, setShowSearcher] = useState<boolean>(false);
    const { selectedCustomer, selectedPriceList, selectedSalesman, dataSearch } = useSearcherStore();
    const { productsCount } = useShoppingCartStore();
    const { n_tickets } = useTicketStore()

    const navigate = useNavigate()
    const { navOpen, openNavSection } = useNavSectionStore();
    const { openDrawer, drawerOpen } = useDrawerStore();

    const BACKGROUND_COLOR = '#fff'
    const ICON_COLOR_HEADER = '#7a7a7a'
    const HEADER_MOBILE = 64
    const HEADER_DESKTOP = 50

    const NAV_WIDTH = navOpen ? 280 : 0


    const StyledRoot = styled(AppBar)(({ theme }) => ({
        backgroundColor: BACKGROUND_COLOR,
        borderBottom: 'solid 1px #dddddd',
        boxShadow: 'none',
        [theme.breakpoints.up('lg')]: {
            width: `calc(100% - ${NAV_WIDTH}px)`,
            maxHeight: '75px',
            minHeight: '75px',
            marginTop: '10px',
            overflow: 'hidden',
            borderBottom: 'solid 1px #dddddd',
        },
    }))

    const StyledToolbar = styled(Toolbar)(({ theme }) => ({
        alignItems: 'center',
        minHeight: HEADER_MOBILE,
        display: 'flex',
        [theme.breakpoints.up('lg')]: {
            minHeight: HEADER_DESKTOP,
            padding: theme.spacing(0, 3),
        },
    }))

    const handleSearch = (term) => {
        setdatasearch([]);
        setSearch(term);
        clearTimeout(searchTimeout)
        setSearchTimeout(setTimeout(() => {
            getSearchProducts({
                search: term,
                idcustomer: selectedCustomer?.id ?? '',
                idsalesman: selectedSalesman?.id ?? '',
                idcategory: '',
                idsubcategory: '',
                idspecificsubcategory: ''
            })
        }, 500)
        );
    };

    const clearSearch = () => {
        setSearch('')
    }

    const onPrincipal = () => {
        nagivate({ pathname: RoutesMap.SEARCHER_V3 })
    }

    return (
        <>
            <StyledRoot>
                <StyledToolbar>
                    <IconButton
                        onClick={() => openDrawer(!drawerOpen)}
                        sx={{
                            mr: 1,
                            color: 'text.primary',
                            display: { lg: 'none', xl: 'none' },
                        }}
                    >
                        <MenuIcon sx={{ color: ICON_COLOR_HEADER }} />
                    </IconButton>

                    <Grid mt={2}>
                        <IconButton
                            onClick={() => openNavSection(!navOpen)}
                            sx={{
                                mr: 1,
                                color: 'text.primary',
                                display: { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block' },
                            }}
                        >
                            <MenuIcon sx={{ color: ICON_COLOR_HEADER }} />
                        </IconButton>
                    </Grid>
                    <Grid container spacing={2} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-around' }}>
                        <Grid item xs={1} md={1}>
                            <img style={{ width: '70px' }} src={logoheader} alt="logo" />
                        </Grid>
                        {!navOpen && <Grid item xs={4.5} md={4}>
                            <Box sx={{
                                width: '100%',
                                // display: 'flex',
                                // justifyContent: 'space-between'
                            }}>
                                <Button
                                    sx={{ color: '#000000', fontSize: '12px', fontWeight: 'bolder' }}
                                    onClick={() => onPrincipal()}
                                >
                                    Principal
                                </Button>
                                <Badge badgeContent={n_tickets || 0} color="error">
                                    <Button
                                        sx={{ color: '#000000', fontSize: '12px', fontWeight: 'bolder' }}
                                        onClick={() => navigate({ pathname: RoutesMap.TICKET_LIST_V3 })}
                                    >
                                        Tickets
                                    </Button>
                                </Badge>
                            </Box>
                        </Grid>}
                        {navOpen && <Grid item xs={4.5} md={4}>
                        </Grid>}
                        <Grid item xs={4} md={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Searcher setShowSearcher={setShowSearcher} />
                        </Grid>
                        <Grid item xs={2} md={2} container justifyContent="flex-end">
                            <IconButton>
                                <AccountPopover />
                            </IconButton>
                        </Grid>
                    </Grid>
                </StyledToolbar>
            </StyledRoot>

            {/*Buscador */}
            {showSearcher && <SearcherV3Popover setShowSearcher={setShowSearcher} handleSelectProduct={handleSelectProduct} showMoreProduct={showMoreProduct}/>}
        </>
    )
}

export default HeaderV3